// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__i6-b4","text":"SelectPayment_text__1nALK","title":"SelectPayment_title__329Xd","btn":"SelectPayment_btn__6Zlqy"};